import {writable} from 'svelte/store';

import {DefaultRideType} from '@js/components/modules/constants';


const initState = {
    map: null,

    mapLocation: undefined,
    // Object of {lat:, lng:}
    startPointLocation: undefined,

    currentRideType: window.currentUserRideType || DefaultRideType,

    // Distance in meters
    currentDistance: 0,

    // Duration in seconds
    currentDuration: 0,
    durationComputed: false,

    // Break time in seconds
    currentBreakTime: 0,

    // Speed in km/h
    currentSpeed: 0,
    speedComputed: true,

    currentCalories: 0,

    currentLevel: undefined,

    isochroneType: null,
    isochroneValue: 0,

    // Duration to reach ride start point from user location
    timeToStartDuration: 0,
    // Object of {mode:, lat:, lng:, value:}
    userCurrentLocation: undefined,

    elevationApsis: {
        positiveElevation: null,
        negativeElevation: null,
        minimumAltitude: null,
        maximumAltitude: null,
        gradeAvg: null
    },

    isSlopePercentageEnabled: false,
    isSurfaceTypeEnabled: false
};

function MapStore(state = initState) {
    const {
        subscribe,
        // set,
        update
    } = writable(
        state
    );

    function updateState(data) {
        Object.entries(data)
            .forEach(([dataName, newData]) => {
                update((storeState) => {
                    storeState[dataName] = newData;

                    return storeState;
                });
            });
    }

    return {
        subscribe,
        get state() {
            return state;
        },
        get map() {
            return state.map;
        },
        set map(map) {
            updateState({map});
        },
        get mapLocation() {
            return state.mapLocation;
        },
        set mapLocation(mapLocation) {
            updateState({mapLocation});
        },
        get startPointLocation() {
            return state.startPointLocation;
        },
        set startPointLocation(startPointLocation) {
            updateState({startPointLocation});
        },
        get currentDistance() {
            return state.currentDistance;
        },
        set currentDistance(currentDistance) {
            updateState({currentDistance});
        },
        get currentDuration() {
            return state.currentDuration;
        },
        set currentDuration(currentDuration) {
            updateState({currentDuration});
        },
        get durationComputed() {
            return state.durationComputed;
        },
        set durationComputed(durationComputed) {
            updateState({durationComputed});
        },
        get currentBreakTime() {
            return state.currentBreakTime;
        },
        set currentBreakTime(currentBreakTime) {
            updateState({currentBreakTime});
        },
        get currentSpeed() {
            return state.currentSpeed;
        },
        set currentSpeed(currentSpeed) {
            updateState({currentSpeed});
        },
        get speedComputed() {
            return state.speedComputed;
        },
        set speedComputed(speedComputed) {
            updateState({speedComputed});
        },
        get currentCalories() {
            return state.currentCalories;
        },
        set currentCalories(currentCalories) {
            updateState({currentCalories});
        },
        get currentLevel() {
            return state.currentLevel;
        },
        set currentLevel(currentLevel) {
            updateState({currentLevel});
        },
        get isochroneType() {
            return state.isochroneType;
        },
        set isochroneType(isochroneType) {
            updateState({isochroneType});
        },
        get isochroneValue() {
            return state.isochroneValue;
        },
        set isochroneValue(isochroneValue) {
            updateState({isochroneValue});
        },
        get timeToStartDuration() {
            return state.timeToStartDuration;
        },
        set timeToStartDuration(timeToStartDuration) {
            updateState({timeToStartDuration});
        },
        get userCurrentLocation() {
            return state.userCurrentLocation;
        },
        set userCurrentLocation(userCurrentLocation) {
            updateState({userCurrentLocation});
        },
        get elevationApsis() {
            return state.elevationApsis;
        },
        set elevationApsis(elevationApsis) {
            updateState({elevationApsis});
        },
        get currentRideType() {
            return state.currentRideType;
        },
        set currentRideType(currentRideType) {
            updateState({currentRideType});
        },
        get isSlopePercentageEnabled() {
            return state.isSlopePercentageEnabled;
        },
        set isSlopePercentageEnabled(isSlopePercentageEnabled) {
            updateState({isSlopePercentageEnabled});
        },
        get isSurfaceTypeEnabled() {
            return state.isSurfaceTypeEnabled;
        },
        set isSurfaceTypeEnabled(isSurfaceTypeEnabled) {
            updateState({isSurfaceTypeEnabled});
        }
    };
}

export const mapStore = MapStore();
